// import React, { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';

// const OnboardingComplete = () => {
//   const [searchParams] = useSearchParams();
//   const [redirectAttempted, setRedirectAttempted] = useState(false);
//   const [showManualRedirect, setShowManualRedirect] = useState(false);
//   const cleanerId = searchParams.get("cleanerId");

//   // Create the deep link URL
//   const deepLink = cleanerId 
//     ? `com.flavoursoft.freshsweeperv5://onboarding-complete?cleanerId=${cleanerId}`
//     : `com.flavoursoft.freshsweeperv5://onboarding-complete`;

//   useEffect(() => {
//     // Don't redirect immediately when coming from Stripe
//     // Instead, show a button or countdown
//     const timer = setTimeout(() => {
//       setShowManualRedirect(true);
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, []);

//   const redirectToApp = () => {
//     console.log('🔗 Redirecting to app:', deepLink);
//     setRedirectAttempted(true);
    
//     // Try multiple methods for better compatibility
//     const methods = [
//       () => { window.location.href = deepLink; },
//       () => { window.location.replace(deepLink); },
//       () => { 
//         const iframe = document.createElement('iframe');
//         iframe.style.display = 'none';
//         iframe.src = deepLink;
//         document.body.appendChild(iframe);
//         setTimeout(() => document.body.removeChild(iframe), 1000);
//       }
//     ];
    
//     // Try each method
//     methods.forEach(method => {
//       try {
//         method();
//       } catch (e) {
//         console.log('Redirect method failed:', e);
//       }
//     });

//     // Fallback to web after delay
//     setTimeout(() => {
//       if (document.visibilityState === 'visible') {
//         console.log('📱 App not installed, staying on web');
//         // Optionally redirect to web dashboard
//         // window.location.href = `/dashboard?cleanerId=${cleanerId}`;
//       }
//     }, 2000);
//   };

//   return (
//     <div style={styles.container}>
//       <h2>🎉 Onboarding Complete!</h2>
      
//       {cleanerId && (
//         <div style={styles.infoBox}>
//           <p><strong>Cleaner ID:</strong> {cleanerId}</p>
//         </div>
//       )}

//       {!showManualRedirect ? (
//         <p>Processing your Stripe onboarding completion...</p>
//       ) : (
//         <>
//           <p>Your Stripe account setup is complete!</p>
          
//           <div style={styles.buttonContainer}>
//             <button 
//               onClick={redirectToApp}
//               style={styles.primaryButton}
//             >
//               Open FreshSweeper App
//             </button>
            
//             <p style={styles.note}>
//               If the app doesn't open automatically, tap the button above.
//             </p>
            
//             <div style={styles.alternativeButtons}>
//               <a href={`/dashboard?cleanerId=${cleanerId}`} style={styles.secondaryButton}>
//                 Continue on Web
//               </a>
//               <a href="/" style={styles.tertiaryButton}>
//                 Go to Homepage
//               </a>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// const styles = {
//   container: {
//     padding: '40px 20px',
//     textAlign: 'center',
//     fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//     maxWidth: '600px',
//     margin: '0 auto',
//     minHeight: '100vh',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   infoBox: {
//     background: '#f8f9fa',
//     padding: '15px',
//     borderRadius: '8px',
//     margin: '20px 0',
//     border: '1px solid #e9ecef',
//   },
//   fallback: {
//     marginTop: '30px',
//     padding: '20px',
//     background: '#fff',
//     borderRadius: '12px',
//     boxShadow: '0 2px 12px rgba(36, 48, 63, 0.08)',
//     border: '1px solid #e0e0e0',
//   },
//   buttonContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '10px',
//     margin: '20px 0',
//   },
//   primaryButton: {
//     display: 'inline-block',
//     padding: '12px 24px',
//     backgroundColor: '#00BFFF',
//     color: 'white',
//     textDecoration: 'none',
//     borderRadius: '8px',
//     fontWeight: '600',
//     fontSize: '16px',
//     transition: 'background-color 0.2s',
//   },
//   secondaryButton: {
//     display: 'inline-block',
//     padding: '12px 24px',
//     backgroundColor: '#6c757d',
//     color: 'white',
//     textDecoration: 'none',
//     borderRadius: '8px',
//     fontWeight: '600',
//     fontSize: '16px',
//     transition: 'background-color 0.2s',
//   },
// };

// export default OnboardingComplete;




import React, { useEffect, useState, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Container,
  Box,
  Paper,
  Typography,
  Chip,
  Button,
  Divider,
  CircularProgress,
  Stack,
  Fade,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';   // ✅ fixed import
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';

// ─── Styled components ──────────────────────────────────────
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(5, 4),
  maxWidth: 480,
  width: '100%',
  margin: '0 auto',
  borderRadius: theme.spacing(3),
  textAlign: 'center',
  background: 'rgba(255,255,255,0.85)',
  backdropFilter: 'blur(8px)',
  boxShadow: '0 20px 60px rgba(0,20,40,0.12), 0 8px 24px rgba(0,20,40,0.06)',
  transition: 'box-shadow 0.3s ease',
  '&:hover': {
    boxShadow: '0 30px 80px rgba(0,20,40,0.16)',
  },
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 80,
  height: 80,
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #00c6ff, #0072ff)',
  color: '#fff',
  marginBottom: theme.spacing(2),
  boxShadow: '0 8px 24px rgba(0,114,255,0.3)',
}));

const CountdownText = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
}));

// ─── Main Component ──────────────────────────────────────────
const OnboardingComplete = () => {
  const [searchParams] = useSearchParams();
  const cleanerId = searchParams.get('cleanerId');

  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [canRedirect, setCanRedirect] = useState(false);

  const deepLink = cleanerId
    ? `com.flavoursoft.freshsweeperv5://onboarding-complete?cleanerId=${cleanerId}`
    : `com.flavoursoft.freshsweeperv5://onboarding-complete`;

  useEffect(() => {
    if (countdown <= 0) {
      setCanRedirect(true);
      return;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  useEffect(() => {
    if (canRedirect) {
      handleRedirect();
    }
  }, [canRedirect]);

  const handleRedirect = useCallback(() => {
    if (redirectAttempted) return;
    setRedirectAttempted(true);
    console.log('🔗 Redirecting to app:', deepLink);

    const methods = [
      () => (window.location.href = deepLink),
      () => window.location.replace(deepLink),
      () => {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = deepLink;
        document.body.appendChild(iframe);
        setTimeout(() => document.body.removeChild(iframe), 1000);
      },
    ];
    methods.forEach((fn) => {
      try {
        fn();
      } catch (_) {}
    });

    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        console.log('📱 App not installed – stay on web');
      }
    }, 2500);
  }, [deepLink, redirectAttempted]);

  const handleManualRedirect = () => {
    setCanRedirect(true);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(145deg, #f6f9fc 0%, #e9f1f8 100%)',
        py: 4,
      }}
    >
      <Fade in timeout={600}>
        <StyledPaper elevation={0}>
          <IconWrapper>
            <CheckCircleIcon sx={{ fontSize: 48 }} />
          </IconWrapper>

          <Typography variant="h4" fontWeight={700} gutterBottom>
            All set!
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Your Stripe onboarding is complete. You’re ready to start using the
            FreshSweeper app.
          </Typography>

          {cleanerId && (
            <Chip
              label={
                <>
                  Cleaner ID: <strong>{cleanerId}</strong>
                </>
              }
              variant="outlined"
              sx={{ mb: 3, px: 1, py: 2, borderRadius: 20 }}
            />
          )}

          {!canRedirect ? (
            <>
              <CountdownText>
                <CircularProgress size={20} thickness={5} sx={{ mr: 1 }} />
                <Typography variant="body2">
                  Opening app in {countdown}s…
                </Typography>
              </CountdownText>
              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={handleManualRedirect}
                startIcon={<OpenInNewIcon />}  // ✅ fixed icon
                sx={{
                  borderRadius: 60,
                  py: 1.2,
                  background: 'linear-gradient(135deg, #00c6ff, #0072ff)',
                  boxShadow: '0 4px 14px rgba(0,114,255,0.35)',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 24px rgba(0,114,255,0.45)',
                  },
                }}
              >
                Open Now
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={handleRedirect}
              disabled={redirectAttempted}
              startIcon={<OpenInNewIcon />}  // ✅ fixed icon
              sx={{
                borderRadius: 60,
                py: 1.2,
                background: 'linear-gradient(135deg, #00c6ff, #0072ff)',
                boxShadow: '0 4px 14px rgba(0,114,255,0.35)',
                '&:hover:not(:disabled)': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 24px rgba(0,114,255,0.45)',
                },
              }}
            >
              {redirectAttempted ? 'Opening…' : 'Open FreshSweeper App'}
            </Button>
          )}

          <Divider sx={{ my: 3 }} />

          <Stack spacing={1.5}>
            <Button
              variant="outlined"
              size="medium"
              fullWidth
              href={`/dashboard?cleanerId=${cleanerId}`}
              startIcon={<DashboardIcon />}
              sx={{ borderRadius: 60, py: 1 }}
            >
              Continue on Web
            </Button>
            <Button
              variant="text"
              size="small"
              href="/"
              startIcon={<HomeIcon />}
              sx={{ color: 'text.secondary', textTransform: 'none' }}
            >
              Go to Homepage
            </Button>
          </Stack>
        </StyledPaper>
      </Fade>
    </Container>
  );
};

export default OnboardingComplete;